module.exports = __webpack_public_path__ + "images/landing_mgp_headphones.8468716d46389b6d4ad962c2bc67da04.jpg";